export default function queryParams() {
  const regex = /(\?|&)([^&=]*)=([^&]*)/g
  let match
  const result = []
  while((match = regex.exec(window.location.search))) {
    const key = decodeURIComponent(match[2].replace(/\+/g, ' '))
    const value = decodeURIComponent(match[3].replace(/\+/g, ' '))

    result.push([key, value])
  }
  return result
}
